import { ReactNode } from 'react';
import { ExpandableBox } from '@optimus-web/helpers';
import { SideMenuPanel } from '../SideMenu';
import { MenuListItem, MenuListItemProps } from './MenuListItem';
import { MenuListElement, MenuListGroup } from './style';

const ListElement = <T,>(
    items: MenuListItemProps<T>[],
    onItemClick?: (id: string) => void,
    activeItem?: string | null
) => (
    <MenuListElement>
        {items.map(({ id, ...others }) => (
            <MenuListItem key={id} items={items} onItemClick={onItemClick} active={activeItem === id} {...others} />
        ))}
    </MenuListElement>
);

export const NestedMenuList = <T,>({
    items,
    onItemClick,
    activeItem,
    expanded,
    collapsed,
    label,
    number,
}: {
    items: MenuListItemProps<T>[];
    onItemClick?: (id: string) => void;
    activeItem?: string | null;
    expanded: boolean;
    collapsed?: boolean;
    label?: ReactNode;
    number?: number;
}) =>
    collapsed ? (
        <SideMenuPanel active={expanded} collapsed={collapsed}>
            <MenuListGroup>
                <div>{label}</div>
                {number ? <div>{number}</div> : null}
            </MenuListGroup>
            {ListElement(items, onItemClick, activeItem)}
        </SideMenuPanel>
    ) : (
        <ExpandableBox expanded={expanded}> {ListElement(items, onItemClick, activeItem)}</ExpandableBox>
    );
